import Accordion from '@/components/sections/shared/Accordion'
import AccordionTab from '@/components/sections/shared/AccordionTab'
import Banner from '@/components/sections/shared/Banner'
import CardGrid from '@/components/sections/shared/CardGrid'
import CardSlider from '@/components/sections/shared/CardSlider'
import Clusters from '@/components/sections/shared/Clusters'
import DoubleParagraph from '@/components/sections/shared/DoubleParagraph'
import Grid from '@/components/sections/shared/Grid'
import Hero from '@/components/sections/shared/Hero'
import IntroText from '@/components/sections/shared/IntroText'
import LogoWall from '@/components/sections/shared/LogoWall'
import Media from '@/components/sections/shared/Media'
import MediaBanner from '@/components/sections/shared/MediaBanner'
import Newsletter from '@/components/sections/shared/Newsletter'
import Paragraph from '@/components/sections/shared/Paragraph'
import Spacer from '@/components/sections/shared/Spacer'
import Table from '@/components/sections/shared/Table'

export const sectionsMap: any = {
  accordion: Accordion,
  accordion_tab: AccordionTab,
  banner: Banner,
  card_grid: CardGrid,
  card_slider: CardSlider,
  clusters: Clusters,
  double_paragraph: DoubleParagraph,
  grid: Grid,
  hero: Hero,
  intro_text: IntroText,
  logo_wall: LogoWall,
  media: Media,
  media_banner: MediaBanner,
  newsletter: Newsletter,
  paragraph: Paragraph,
  spacer: Spacer,
  table: Table
}
